module.exports = __webpack_public_path__ + "img/icon-pinterest.ef15af23.svg";